import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"

import "./Form.vue?vue&type=style&index=0&id=44241914&lang=scss&scoped=true"
script.__scopeId = "data-v-44241914"

export default script